import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { PassChangeReason } from "../models/PassChangeReason";

export const getPassChangeReasons = async ({
	id = null,
}: {
	id?: number | null;
} = {}): Promise<PassChangeReason[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "OnlyActives", value: false }];

	if (id) {
		parameters.push({ name: "Id", value: id });
	}

	const resp = await apiService.callV2(
		"[MILL].[GetPassChangeReasons]",
		parameters,
	);

	if (resp.ok) {
		const rows = get(resp, "data.tables[0].rows", []) as PassChangeReason[];
		return rows;
	}
	throw new Error(resp.message || "Error fetching pass change reasons");
};

export const upsertPassChangeReason = async (
	reason: PassChangeReason,
): Promise<PassChangeReason> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "Id", value: reason.Id },
		{ name: "Name", value: reason.Name },
		{ name: "Description", value: reason.Description },
		{ name: "Active", value: reason.Active },
	];

	const resp = await apiService.callV2(
		"[MILL].[UpsertPassChangeReason]",
		parameters,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows[0]", null) as PassChangeReason;
	}
	throw new Error(resp.message || "Error saving pass change reason");
};

export const removePassChangeReason = async (id: number): Promise<void> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "Id", value: id }];

	const resp = await apiService.callV2(
		"[MILL].[RemovePassChangeReason]",
		parameters,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error deleting pass change reason");
	}
};
